import { render, staticRenderFns } from "./BbvaForm.vue?vue&type=template&id=5d2ad56e"
import script from "./BbvaForm.vue?vue&type=script&lang=js"
export * from "./BbvaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports